import React from "react";
import founderPhoto from "./assets/venkata-martha.jpg";

export function TeamPage() {
  return (
    <main className="team-page page-shell">
      <p className="eyebrow">THE PEOPLE BUILDING NORI</p>
      <h1>Small team.<br /><em>Focused on the hard parts.</em></h1>
      <p className="team-intro">Nori is being built by a team of three engineers working across the customer experience, business tools, and the integrations that connect them.</p>
      <div className="team-profile">
        <img className="team-photo" src={founderPhoto} alt="Venkata Martha, founder of Nori" width="720" height="853" />
        <div>
          <p className="eyebrow">FOUNDER</p>
          <h2>Venkata Martha</h2>
          <p className="team-role">Founder, Nori</p>
          <p>Venkata is an engineering leader who builds customer-facing platforms. He started Nori to give businesses a place of their own for the relationship that begins after the first visit.</p>
          <dl className="team-facts">
            <div><dt>Experience</dt><dd>Amazon, Walmart, Indeed, Yahoo, Lore IO</dd></div>
            <div><dt>Education</dt><dd>Ph.D. in Computer Science. MBA candidate, Carnegie Mellon Tepper (2028)</dd></div>
            <div><dt>Based in</dt><dd>Fremont, CA</dd></div>
          </dl>
        </div>
      </div>
      <p className="team-note">The next step is to put the first workflows in the hands of design partners and measure what they change.</p>
    </main>
  );
}
